module.exports = "https://trybtryb-legacy.web.app/img/event.0a255082.svg";